export type Category = {
  id?: number
  name: string
}

export const initValues: Category = {
  id: undefined,
  name: '',
}
